<template>
  <div>
    <h2 class="text-2xl font-bold text-gray-900 mb-3 leading-snug">
      Setup complete - your module queue
    </h2>
    <p class="text-sm leading-relaxed text-gray-700 mb-5">
      Only the modules relevant to your architecture are shown. Complete
      them in order to finish your HR configuration.
    </p>

    <div class="queue-success-banner flex items-center gap-3 px-3 py-3 rounded-lg mb-4">
      <span
        class="queue-success-banner__icon flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center"
      >
        <Icon icon-name="icon-info" size="xxs" class="text-green-700" />
      </span>
      <p class="text-xs m-0">
        Architecture configuration saved. Your account is now configured
        and ready for module setup.
      </p>
    </div>

    <div class="queue-list">
      <div
        v-for="item in moduleQueueRows"
        :key="item.label"
        class="queue-row flex items-center justify-between gap-4"
      >
        <div class="flex items-center gap-3 min-w-0">
          <span
            class="queue-row__index w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold text-gray-800"
          >
            {{ item.index }}
          </span>
          <p class="text-sm text-gray-900 font-semibold m-0 truncate">
            {{ item.label }}
          </p>
        </div>

        <span
          class="queue-row__status px-3 py-1 rounded-lg text-xs font-bold whitespace-nowrap"
          :class="
            item.status === 'Up next'
              ? 'queue-row__status--upnext'
              : 'queue-row__status--pending'
          "
        >
          {{ item.status }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from "@/components/Icon";

export default {
  name: "OrgOnboardingStep3",
  components: { Icon },
  props: {
    moduleQueueRows: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.queue-success-banner {
  background: #e9fbef;
  border: 1px solid #b8efc9;
}

.queue-success-banner__icon {
  background: #d8f8e2;
}

.queue-list {
  border-top: 1px solid #f1f5f9;
}

.queue-row {
  padding: 12px 0;
  border-bottom: 1px solid #f1f5f9;
}

.queue-row__index {
  background: #f8fafc;
}

.queue-row__status {
  border: 1px solid transparent;
}

.queue-row__status--upnext {
  color: #f15a29;
  border-color: #f15a29;
}

.queue-row__status--pending {
  color: #e99323;
  border-color: #e99323;
}
</style>

